import { Component, OnInit } from '@angular/core';
import { UtilitiesService } from '../services/utilities.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../services/api.service';
import Swal from 'sweetalert2'
import { HttpParams } from '@angular/common/http';
import { PageEvent } from '@angular/material/paginator';

@Component({
    selector: 'app-invoices',
    templateUrl: './invoices.component.html',
    styleUrls: ['./invoices.component.css'],
    standalone: false
})
export class InvoicesComponent implements OnInit {
  page = 1;
  pageSize = 10;

  list_length = 0;
  items: any[] = [];
  token: any;

  Swal = 'sweetalert2';

  patient_id: any;

  filter_config: any;

  constructor(public utility: UtilitiesService, private modalService: NgbModal, private api: ApiService, private route: ActivatedRoute, private router: Router) {
    this.utility.show = true;
    this.token = localStorage.getItem('access_token');
    this.filter_config = {
      itemsPerPage: 10,
      currentPage: 1,
      totalItems: 0,
      sort: null,
      sort_order: 'asc',
      pageSizeOptions: [5, 10, 25, 100]
    };
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.patient_id = params['id'] != null ? params['id'] : null;
      if (this.patient_id) this.checkFilter();
      else this.getItems();
    });
  }

  getHttpParams() {
    let params = new HttpParams();
    params = params.append('page', this.filter_config.currentPage.toString());
    params = params.append('per_page', this.filter_config.itemsPerPage.toString());
    if (this.filter_config.sort) {
      params = params.append('sort', this.filter_config.sort);
      params = params.append('sort_order', this.filter_config.sort_order);
    }
    if (this.filter_config.queries) {
      params = params.append('queries', this.filter_config.queries);
    }
    return params;
  }
  pageChangeEvent(event: PageEvent) {
    this.filter_config.currentPage = event.pageIndex + 1;
    this.filter_config.itemsPerPage = event.pageSize;
    this.getItems();
  }

  getItems() {
    this.utility.loading = true;
    const sub = this.api.get('payments/', this.token, { params: this.getHttpParams() }).subscribe(
      async data => {
        let objects: any = {}
        objects = data;

        this.items = objects.payments;
        this.list_length = this.items.length;
        this.filter_config.totalItems = objects['filters']['total_results'];
      },
      async error => { }
    );
    sub.add(() => { this.utility.loading = false; });
  }

  open_invoice(id: any) {
    this.router.navigate([]).then(result => { window.open('invoice_print?id=' + id, '_blank'); });
  }

  checkFilter() {
    if (this.patient_id.length >= 3) {
      let field = 'client_id';
      let value = this.patient_id;

      this.filter_config.queries = `${field},eq,${value}`;
      this.getItems();
    }

    if (this.patient_id == '' || this.patient_id == null) {
      this.filter_config.queries = null;
      this.getItems();
    }
  }
}
